import { logger } from '@/lib/telemetry/logger';

export const EARLY_ACCESS_STORAGE_KEY = 'morfi_beta_access';
export const EARLY_ACCESS_DATASET_ATTR = 'morfiBetaAccess';
export const EARLY_ACCESS_DATASET_VALUE = 'granted';
const EARLY_ACCESS_CHANGE_EVENT = 'morfi-beta-access-change';

export function hasStoredAccess(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return localStorage.getItem(EARLY_ACCESS_STORAGE_KEY) === 'true';
  } catch (err: unknown) {
    logger.warn('localStorage read failed for beta access check', {
      error: err instanceof Error ? err.message.slice(0, 200) : String(err),
    });
    return false;
  }
}

export function storeAccess(): void {
  try {
    localStorage.setItem(EARLY_ACCESS_STORAGE_KEY, 'true');
    document.documentElement.dataset[EARLY_ACCESS_DATASET_ATTR] = EARLY_ACCESS_DATASET_VALUE;
    window.dispatchEvent(new Event(EARLY_ACCESS_CHANGE_EVENT));
  } catch (err: unknown) {
    logger.warn('localStorage write failed for beta access', {
      error: err instanceof Error ? err.message.slice(0, 200) : String(err),
    });
  }
}

export function clearBetaAccess(): void {
  try {
    localStorage.removeItem(EARLY_ACCESS_STORAGE_KEY);
    delete document.documentElement.dataset[EARLY_ACCESS_DATASET_ATTR];
    window.dispatchEvent(new Event(EARLY_ACCESS_CHANGE_EVENT));
  } catch (err: unknown) {
    logger.warn('localStorage remove failed for beta access', {
      error: err instanceof Error ? err.message.slice(0, 200) : String(err),
    });
  }
}

export function subscribeBetaAccess(onStoreChange: () => void): () => void {
  const onStorage = (event: StorageEvent): void => {
    if (event.key === EARLY_ACCESS_STORAGE_KEY || event.key === null) {
      onStoreChange();
    }
  };
  window.addEventListener('storage', onStorage);
  window.addEventListener(EARLY_ACCESS_CHANGE_EVENT, onStoreChange);
  return (): void => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(EARLY_ACCESS_CHANGE_EVENT, onStoreChange);
  };
}

export function getBetaAccessSnapshot(): boolean {
  return hasStoredAccess();
}
